"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ProviderIntent = _interopRequireDefault(require("../components/ProviderIntent.js"));
var _consts = require("../consts.js");
var _providerEvents = _interopRequireDefault(require("wix-art-store-3rd-party/dist/src/sdk/providerEvents"));
var _WixSDKProviderApi = _interopRequireDefault(require("../components/WixSDKProviderApi"));
var _wixSdkOOI = _interopRequireDefault(require("../gallery/wixSdkOOI"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var ThankyouIntentOOI = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ThankyouIntentOOI, _Component);
  function ThankyouIntentOOI(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      height: null
    };
    return _this;
  }
  var _proto = ThankyouIntentOOI.prototype;
  _proto.handleThankyouMessageReceived = function handleThankyouMessageReceived(type, payload, resolve, reject) {
    var storeApi = this.props.storeApi;
    switch (type) {
      case _providerEvents["default"].setHeight:
        this.setState({
          height: payload.height
        });
        break;
      case _providerEvents["default"].clearCart:
        storeApi.clearCart();
        break;
      case _providerEvents["default"].backHome:
        storeApi.backHome();
        break;
      default:
        break;
    }
  };
  _proto.init = function init() {
    this.props.tryToReportAppLoaded();
    if (!this.wixSdk) {
      var _this$props = this.props,
        baseUrl = _this$props.baseUrl,
        sectionsUrls = _this$props.sectionsUrls,
        visitorId = _this$props.visitorId,
        metaSiteId = _this$props.metaSiteId,
        locale = _this$props.locale,
        _this$props$host = _this$props.host,
        formFactor = _this$props$host.formFactor,
        style = _this$props$host.style;
      var getDeviceType = function getDeviceType(type) {
        return type === 'mobile' || type === 'tablet' ? 'mobile' : 'desktop';
      };
      this.wixSdk = (0, _wixSdkOOI["default"])({
        baseUrl: baseUrl,
        sectionsUrls: sectionsUrls,
        visitorId: visitorId,
        metaSiteId: metaSiteId,
        locale: locale,
        deviceType: getDeviceType(formFactor.toLowerCase()),
        style: style
      });
    }
  };
  _proto.getConsentPolicyQuery = function getConsentPolicyQuery(consentPolicy) {
    if (consentPolicy && consentPolicy.policy) {
      return encodeURIComponent(JSON.stringify(consentPolicy));
    } else {
      return undefined;
    }
  };
  _proto.getQueryParams = function getQueryParams() {
    var _this$props2 = this.props,
      consentPolicy = _this$props2.consentPolicy,
      queryParams = _this$props2.queryParams;
    var search = queryParams;
    var _consentPolicy = consentPolicy || queryParams.consentPolicy;
    if (_consentPolicy) {
      search.consentPolicy = this.getConsentPolicyQuery(_consentPolicy);
    }
    return search;
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props3 = this.props,
      connectedProviders = _this$props3.connectedProviders,
      host = _this$props3.host;
    if (!connectedProviders) {
      return null;
    }
    this.init();
    var height = this.state.height;
    var styles = height ? {
      height: height + 'px'
    } : {};
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: styles
    }, /*#__PURE__*/_react["default"].createElement(_ProviderIntent["default"], {
      api: new _WixSDKProviderApi["default"](this.wixSdk),
      connectedProviders: connectedProviders,
      hiddenFromEditor: true,
      ref: function ref(element) {
        return _this2.intent = element;
      },
      viewMode: host.viewMode.toLowerCase(),
      intent: _consts.providerIntents.thankyou,
      onMessageReceived: function onMessageReceived(type, payload, resolve, reject, providerId) {
        return _this2.handleThankyouMessageReceived(type, payload, resolve, reject, providerId);
      },
      additionalParams: this.getQueryParams()
    }));
  };
  return ThankyouIntentOOI;
}(_react.Component);
var _default = exports["default"] = ThankyouIntentOOI;